import { render, staticRenderFns } from "./ViewImage.vue?vue&type=template&id=7deda342&"
import script from "./ViewImage.vue?vue&type=script&lang=js&"
export * from "./ViewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports